document.addEventListener('DOMContentLoaded', function() {
  const isMobile = window.matchMedia('(max-width: 1079px)').matches;
  const searchForm = document.querySelector('.header-search-form');
  const searchInput = document.querySelector('.header-search-input');
  const searchButton = document.querySelector('[data-header-search-button]');

  if (!searchForm || !searchInput) {
    return;
  }

  if (isMobile) {
    const closeButton = document.querySelector('[data-header-search-button-close]');

    if (!closeButton) {
      return;
    }

    let overlay = document.querySelector('.search-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'search-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      searchForm.after(overlay);
    }

    function toggleSearch(show) {
      if (show) {
        searchForm.classList.add('active');
        overlay.setAttribute('aria-hidden', 'false');
        searchInput.focus();
        document.body.style.overflow = 'hidden';
      } else {
        searchForm.classList.remove('active');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        searchInput.value = '';
      }
    }

    searchForm.addEventListener('click', function(e) {
      if (e.target === searchForm) {
        e.preventDefault();
        toggleSearch(true);
      }
    });

    if (searchButton) {
      searchButton.addEventListener('click', function(e) {
        e.preventDefault();
        toggleSearch(true);
      });
    }

    closeButton.addEventListener('click', function() {
      toggleSearch(false);
    });

    overlay.addEventListener('click', function() {
      toggleSearch(false);
    });

    function handleEscapeKey(e) {
      if (e.key === 'Escape' && searchForm.classList.contains('active')) {
        toggleSearch(false);
      }
    }
    document.addEventListener('keydown', handleEscapeKey);

    searchForm.addEventListener('submit', function(e) {
      if (!searchInput.value.trim()) {
        e.preventDefault();
      }
    });

    return;
  }

  let usfSearchInitialized = false;
  let usfInitAttempts = 0;
  const maxUSFInitAttempts = 10;

  function isUSFReady() {
    return (
      typeof window.usf !== 'undefined' &&
      window.usf.utils &&
      typeof window.usf.utils.installSearchInput === 'function'
    );
  }

  function initUSFSearch() {
    if (usfSearchInitialized) {
      return;
    }

    if (!searchInput || !document.body.contains(searchInput)) {
      return;
    }

    if (!isUSFReady()) {
      return;
    }

    try {
      window.usf.utils.installSearchInput(searchInput);
      usfSearchInitialized = true;
    } catch (error) {
      usfInitAttempts += 1;

      if (usfInitAttempts < maxUSFInitAttempts) {
        setTimeout(initUSFSearch, 300);
        return;
      }

      console.warn('USF search input was not initialized:', error);
    }
  }

  function startUSFSearchInit() {
    const checkUSF = setInterval(function() {
      if (usfSearchInitialized) {
        clearInterval(checkUSF);
        return;
      }

      if (isUSFReady()) {
        initUSFSearch();
      }
    }, 300);

    setTimeout(function() {
      clearInterval(checkUSF);
    }, 6000);
  }

  if (document.readyState === 'complete') {
    setTimeout(startUSFSearchInit, 500);
  } else {
    window.addEventListener('load', function() {
      setTimeout(startUSFSearchInit, 500);
    }, { once: true });
  }

  function showInstantSearch() {
    if (
      typeof window.usf === 'undefined' ||
      !window.usf.utils ||
      typeof window.usf.utils.loadAndShowInstantSearch !== 'function'
    ) {
      return;
    }

    try {
      if (!usfSearchInitialized) {
        initUSFSearch();
      }

      window.usf.utils.loadAndShowInstantSearch(searchInput, true);
    } catch (error) {
      console.warn('USF instant search was not shown:', error);
    }
  }

  if (searchButton) {
    searchButton.addEventListener('click', function(e) {
      e.preventDefault();
      showInstantSearch();
    });
  }

  searchForm.addEventListener('submit', function(e) {
    e.preventDefault();

    if (searchInput.value.trim()) {
      showInstantSearch();
    }
  });
});
